import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

enum FormFieldType {
  select = 'mat-select',
  option = 'mat-option',
  input = 'input',
}

const TEXT_ELEMENT_SELECTOR: { [key: string]: string[] } = {
  [FormFieldType.select]: [
    'mat-select-trigger span',
    '.mat-select-trigger span.mat-select-min-line',
  ],
  [FormFieldType.option]: ['.mat-option-text'],
};

@Directive({
  selector: '[fieldTextContentTooltip]',
  standalone: true,
  providers: [MatTooltip],
})
export class FieldTextContentTooltipDirective {
  @Input() tooltipOnlyWhenContextCropped: boolean = false;

  constructor(private elementRef: ElementRef, private matTooltip: MatTooltip) {}
  private readonly tooltipDelay: number = 1000;

  @HostListener('mouseenter')
  onMouseEnter() {
    this.initMatTooltipForFormField();
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.matTooltip.hide();
  }

  private initMatTooltipForFormField() {
    const fieldType = this.elementRef.nativeElement.tagName.toLowerCase();
    if (!fieldType || !Object.values(FormFieldType).includes(fieldType)) return;

    let optionTextElement: HTMLElement;
    if (fieldType === FormFieldType.select || fieldType === FormFieldType.option) {
      TEXT_ELEMENT_SELECTOR[fieldType].forEach((optionElement: string) => {
        if (this.elementRef.nativeElement.querySelector(optionElement)) {
          optionTextElement = this.elementRef.nativeElement.querySelector(optionElement);
        }
      });
      if (!optionTextElement) return;
    }

    switch (fieldType) {
      case FormFieldType.select:
        const selectWidth = this.elementRef.nativeElement.querySelector('.mat-mdc-select-value')
          .offsetWidth;
        const contentWidth = optionTextElement.offsetWidth;
        if (contentWidth > selectWidth) {
          this.addTooltip(optionTextElement.textContent);
        }
        break;
      case FormFieldType.option:
        if (
          optionTextElement.offsetHeight < optionTextElement.scrollHeight ||
          optionTextElement.offsetWidth < optionTextElement.scrollWidth
        ) {
          this.addTooltip(optionTextElement.textContent);
        }
        break;

      case FormFieldType.input:
        const inputElement = this.elementRef.nativeElement;

        if (inputElement.scrollWidth > inputElement.clientWidth) {
          this.addTooltip(inputElement.value);
        }
        break;
    }
  }

  private addTooltip(message: string) {
    this.matTooltip.message = message.trim();
    this.matTooltip.show(this.tooltipDelay);
  }
}
